import { isNumber } from "@okta/okta-auth-js"
import { ref } from "vue"

class tabActualStatus {
	actualMainTabId: string
	actualSubTabName: string
	selectedStepId: string
	generalInformationId: string
}

class allTabsActualStatus {
	public allTabsStatus: tabActualStatus[]
}

function formatNumberForVisualization(num: number, digit: number): string {
	return num.toLocaleString("en-US", { style: "decimal", minimumFractionDigits: digit, maximumFractionDigits: digit })
}

function formatExponential(num: number): string {
	if (num === 0) return "0"
	let expStr = num.toExponential(2)
	const eIndex = expStr.indexOf("e")
	if (eIndex === -1) return expStr
	let base = expStr.slice(0, eIndex)
	let exponent = expStr.slice(eIndex + 1)
	if (exponent.startsWith("-")) {
		exponent = "-0" + exponent.slice(1)
	} else if (exponent.startsWith("+")) {
		exponent = "+0" + exponent.slice(1)
	} else {
		exponent = "0" + exponent
	}
	return base + "E" + exponent
}

//fomatting calculated numbers in ui
export function uiNumberFormatterAZ(inputNumber: number): string {
	if (inputNumber === null) return "0"
	var result: string = "0"
	//Positive Numbers .toLocaleDateString("en-US", {style: "decimal", minimumFractionDigits: 2,maximumFractionDigits: 2,})
	if (inputNumber < 0.001 && inputNumber >= 0) {
		result = formatExponential(inputNumber)
	} else if (inputNumber < 0.01 && inputNumber >= 0.001) {
		result = formatNumberForVisualization(inputNumber, 5)
	} else if (inputNumber < 0.1 && inputNumber >= 0.01) {
		result = formatNumberForVisualization(inputNumber, 4)
	} else if (inputNumber < 1 && inputNumber >= 0.1) {
		result = formatNumberForVisualization(inputNumber, 3)
	} else if (inputNumber < 10 && inputNumber >= 1) {
		result = formatNumberForVisualization(inputNumber, 2)
	} else if (inputNumber < 100 && inputNumber >= 10) {
		result = formatNumberForVisualization(inputNumber, 1)
	} else if (inputNumber >= 100) {
		result = formatNumberForVisualization(inputNumber, 0)
	}
	//Negative Numbers
	else if (inputNumber > -0.001 && inputNumber < 0) {
		result = formatExponential(inputNumber)
	} else if (inputNumber > -0.01 && inputNumber <= -0.001) {
		result = formatNumberForVisualization(inputNumber, 5)
	} else if (inputNumber > -0.1 && inputNumber <= -0.01) {
		result = formatNumberForVisualization(inputNumber, 4)
	} else if (inputNumber > -1 && inputNumber <= -0.1) {
		result = formatNumberForVisualization(inputNumber, 3)
	} else if (inputNumber > -10 && inputNumber <= -1) {
		result = formatNumberForVisualization(inputNumber, 2)
	} else if (inputNumber > -100 && inputNumber <= -10) {
		result = formatNumberForVisualization(inputNumber, 1)
	} else if (inputNumber <= -100) {
		result = formatNumberForVisualization(inputNumber, 0)
	}
	return result
}

export function getLocalStorageForTypeId(actionType: string, toSave: any = null, tabId: string | null = null): Promise<tabActualStatus | boolean> {
	return new Promise((resolve, reject) => {
		try {
			switch (actionType) {
				case "load":
					const localStorageActualTabs: string | null = localStorage.getItem("actualTabsStatus")
					if (localStorageActualTabs === null) {
						reject("ErrorLine1136")
					} else {
						try {
							const tabStatus: allTabsActualStatus = JSON.parse(localStorageActualTabs) as allTabsActualStatus
							const toGetStatus = tabStatus.allTabsStatus.find((item: tabActualStatus) => item.actualMainTabId === tabId)
							if (toGetStatus === undefined) {
								resolve(false)
							} else {
								resolve(toGetStatus)
							}
						} catch (parseError) {
							reject("ParsingError")
						}
					}
					break
				case "save":
					try {
						localStorage.setItem("actualTabsStatus", JSON.stringify(toSave))
						resolve(true)
					} catch (saveError) {
						reject("SaveError")
					}
					break
				default:
					reject("InvalidActionType")
			}
		} catch (error) {
			reject(error)
		}
	})
}

//excel like colors
export function getExcelLikeColours(value: number, minValue: number, maxValue: number): string {
	// Normalize the value between 0 and 1
	let ratio = (value - minValue) / (maxValue - minValue)
	//console.log("ratio", ratio, value)
	// Calculate colors
	let r, g, b
	if (ratio < 0.5) {
		// Green to Yellow
		r = Math.round(510 * ratio)
		g = 255
		b = 0
	} else {
		// Yellow to Red
		r = 255
		g = Math.round(510 * (1 - ratio))
		b = 0
	}

	// Return the color as a CSS RGB string
	let desaturated = desaturateRGB(r, g, b, 0.2)
	return desaturated
}

function desaturateRGB(r: number, g: number, b: number, desaturationAmount: number): string {
	// Clamp desaturation amount between 0 and 1
	desaturationAmount = Math.max(0, Math.min(1, desaturationAmount))

	// Calculate luminance (perceived grayscale value)
	const gray = 0.3 * r + 0.59 * g + 0.11 * b

	// Interpolate between original color and gray
	const newR = Math.round(r + (gray - r) * desaturationAmount)
	const newG = Math.round(g + (gray - g) * desaturationAmount)
	const newB = Math.round(b + (gray - b) * desaturationAmount)

	return `rgb(${newR},${newG},${newB}, 0.4)`
}

//excel like colors
export function getExcelLikeColoursOLD(value: number, minValue: number, maxValue: number): string {
	// Ensure the value is within the range
	if (value < minValue) value = minValue
	if (value > maxValue) value = maxValue

	// Calculate the ratio of the value between minValue and maxValue
	let ratio = (value - minValue) / (maxValue - minValue)

	// Determine the position of the midpoint (50th percentile)
	let midpoint = 0.5

	let r, g, b

	if (ratio <= midpoint) {
		// Green to Yellow
		ratio = ratio / midpoint
		r = Math.round(255 * ratio)
		g = 255
		b = 0
	} else {
		// Yellow to Red
		ratio = (ratio - midpoint) / (1 - midpoint)
		r = 255
		g = Math.round(255 * (1 - ratio))
		b = 0
	}

	// Return the color as a CSS RGB string
	return `rgb(${r},${g},${b})`
}
